/**
 * Defines the request-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @public
 */
export const CMCD_REQUEST_KEYS = [
	'ab',
	'bg',
	'bl',
	'br',
	'bs',
	'bsa',
	'bsd',
	'bsda',
	'cdn',
	'cid',
	'cs',
	'd',
	'dfa',
	'dl',
	'ec',
	'lab',
	'lb',
	'ltc',
	'msd',
	'mtp',
	'nor',
	'nr',
	'ot',
	'pb',
	'pr',
	'pt',
	'rtp',
	'sf',
	'sid',
	'sn',
	'st',
	'sta',
	'su',
	'tab',
	'tb',
	'tbl',
	'tpb',
	'v',
] as const
